import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";
import "./index.css";

const app = createApp(App) //
  .use(createPinia())
  // .use(store)
  .use(createHead())
  .use(router);

//
app.mount("#app");
